import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { InputFileType } from '@/coreDomainsModule/entities/inputExcelInfo';
import { InputExcelInfosRepository } from '@/coreInfrastructureModule/Repositories/InputExcelInfosRepository';
import { RegisterExcelInfo } from '../pages/interfaces/HomeInput';
import { IYearMonth } from '@/coreDomainsModule/date';

/**
 * 入力エクセルの読み込み情報を取得する(全てのファイルタイプについて取得する)
 */
export class GetExcelInputInfoUseCase {
  /**
   *  データを取得する
   * @param repository - リポジトリ
   */
  public async Execute(repository: InputExcelInfosRepository): Promise<INetworkResult<Record<InputFileType, RegisterExcelInfo>, IError>> {
    try {
      const response = await repository.get();
      if (response.status.type === 'success') {
        const useKey = response.status.data[0];
        return {
          status: {
            type: 'success',
            data: Object.entries(response.status.data[1][useKey]).reduce((acc, [key, value]) => {
              acc[key as InputFileType] = {
                headerLineNumber: value.headerLineNumber,
                alternateHeaderInfos: value.alternateHeaderInfos.map((alternateHeaderInfo) => ({
                  header: alternateHeaderInfo.header,
                  value: alternateHeaderInfo.value,
                  unused: alternateHeaderInfo.unused,
                  validateError: false,
                })),
                selectYearMonthPattern: value.selectYearMonthPattern,
                inlinedYearMonthHeaderName: {
                  headerName: value.inlinedYearMonthHeaderName,
                  validateError: 'none',
                },
                inHeaderYearMonthInfo: {
                  startColumnNumber: {
                    raw: value.inHeaderYearMonthInfo?.startColumnNumber,
                    validateError: 'none',
                  },
                  endColumnNumber: {
                    raw: value.inHeaderYearMonthInfo?.endColumnNumber,
                    validateError: 'none',
                  },
                  start: {
                    raw: this._yearMonthToRawString(value.inHeaderYearMonthInfo?.start),
                    validateError: 'none',
                  },
                  end: {
                    raw: this._yearMonthToRawString(value.inHeaderYearMonthInfo?.end),
                    validateError: 'none',
                  },
                },
              };
              return acc;
            }, {} as Record<InputFileType, any>), // 絶対に存在するはず
          },
        };
      } else {
        return {
          // 基本的にはここには来ない
          status: {
            type: 'error',
            error: response.status.error,
          },
        };
      }
    } catch (error) {
      console.error('error', error); // 基本的にはここには来ない
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: '未知のエラーが発生しました',
          },
        },
      };
    }
  }

  /**
   * 年月情報を文字列に変換する(1~9は0埋め)
   * @param yearMonth - 年月情報
   */
  private _yearMonthToRawString(yearMonth?: IYearMonth): string {
    if (yearMonth == null) {
      return '';
    }
    return `${yearMonth.year}${yearMonth.month.toString().padStart(2, '0')}`;
  }
}
